import { render, staticRenderFns } from "./InstrumentUltimateTzCheckMeBack.vue?vue&type=template&id=18ff8c8f&"
import script from "./InstrumentUltimateTzCheckMeBack.vue?vue&type=script&lang=js&"
export * from "./InstrumentUltimateTzCheckMeBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
